import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { VisitDiagnoses } from '~libs.shared.visit';

import { historicalVisitTranslationKeys } from '../../../../translations';
import { MedicineReplacementForm } from '../../../../features/prescriptions/medicineReplacementModal/form/MedicineReplacementForm';

import { MedicineReplacementFormLoader } from './MedicineReplacementFormLoader';
import { NotCopiedPrescriptionReplacementActionInterceptor } from './NotCopiedPrescriptionReplacementActionInterceptor';

const t = historicalVisitTranslationKeys.copyPrescription;

type NotCopiedPrescriptionReplacementModalProps = {
   readonly medicineId: number;
   readonly count: number;
   readonly patientId: Patient['id'];
   readonly targetVisitId: number;
   readonly visitDiagnoses: VisitDiagnoses;
   readonly onSuccess: VoidFunction | PromiseVoidFunction;
   readonly onCancel: VoidFunction;
};

export const NotCopiedPrescriptionReplacementModal = (
   props: NotCopiedPrescriptionReplacementModalProps
): JSX.Element => {
   return (
      <Modal title={t.replacementModalTitle} width={ModalWidth.WIDE} testId={'notCopiedPrescriptionReplacement'}>
         <MedicineReplacementFormLoader medicineId={props.medicineId} patientId={props.patientId}>
            {({ withdrawnMedicine }) => (
               <MedicineReplacementForm
                  withdrawnMedicine={withdrawnMedicine}
                  patientId={props.patientId}
                  visitDiagnoses={props.visitDiagnoses}
               >
                  {({ handleSubmit, formState, newMedicineSelected }) => (
                     <>
                        <ModalCancelButton
                           onClick={props.onCancel}
                           label={t.skipCopyingThisMedicine}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <NotCopiedPrescriptionReplacementActionInterceptor
                           handleSubmit={handleSubmit}
                           targetVisitId={props.targetVisitId}
                           count={props.count}
                           onSuccess={props.onSuccess}
                        >
                           <ModalConfirmButton
                              testId={'useNewMedicine'}
                              label={t.useNewMedicine}
                              onClick={props.onCancel}
                              disabled={!newMedicineSelected}
                           />
                        </NotCopiedPrescriptionReplacementActionInterceptor>
                        <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </MedicineReplacementForm>
            )}
         </MedicineReplacementFormLoader>
      </Modal>
   );
};
